<template>
	<div class="title-page">
		<h1 class="title">Créer un logement</h1>
	</div>
	<div class="card white">
		<h2>Détails du logement</h2>
		<form @submit.prevent="submitForm">
			<div class="form-group">
				<div class="form-control">
					<label for="register-email">Nom du logement</label>
					<input type="text" id="name" v-model="property.name" required />
				</div>
				<div class="form-control type">
					<label for="register-email">Type</label>
					<select id="type" v-model="property.typ" required>
						<option value="0">Appartement</option>
						<option value="1">Maison</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<div class="form-control address">
					<label class="info-label" for="address">Adresse</label>
					<input type="text" id="address" v-model="searchAddress" @input="searchAddresses" autocomplete="off"
						required />
					<div v-if="searchAddress.length > 0" class="info-message">Sélectionnez une adresse dans la liste des
						propositions.</div>
					<ul v-if="addressOptions.length" class="address-options">
						<li v-for="option in addressOptions" :key="option" @click="selectAddress(option)">{{
							option.label }}</li>
					</ul>
				</div>
				<div class="form-control fiscal">
					<label for="register-email">Numéro fiscal</label>
					<input type="text" id="fiscal_number" v-model="property.fiscal_number" />
				</div>
			</div>
			<input type="hidden" v-model="property.id_ban" name="id_ban" />
			<input type="hidden" v-model="property.lat" name="lat" />
			<input type="hidden" v-model="property.lng" name="lng" />
			<div v-if="errorMessage" class="message">{{ errorMessage }}</div>
			<button type="submit" class="button fill normal" :disabled="isSubmitting">Ajouter</button>
		</form>
	</div>
</template>

<script>
export default {
	name: "MesLogements",
	data() {
		return {
			property: {
				name: "",
				typ: "0",
				id_ban: "",
				lat: "",
				lng: "",
				fiscal_number: "",
			},
			searchAddress: "",
			addressOptions: [],
			errorMessage: "",
			isSubmitting: false,
		};
	},
	methods: {
		async searchAddresses() {
			if (this.searchAddress.length < 3) return;
			try {
				const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${this.searchAddress}&limit=5`);
				const data = await response.json();
				this.addressOptions = data.features.map((feature) => {
					return {
						id: feature.properties.id,
						geometry: feature.geometry,
						label: feature.properties.label,
					};
				});
			} catch (error) {
				console.error("Erreur lors de la recherche d'adresse:", error);
			}
		},
		selectAddress(option) {
			this.property.id_ban = option.id;
			this.property.lat = option.geometry.coordinates[1];
			this.property.lng = option.geometry.coordinates[0];
			this.searchAddress = option.label;
			this.addressOptions = [];
		},
		async submitForm() {
			if (!this.property.id_ban || !this.property.lat || !this.property.lng) return this.errorMessage = "Veuillez sélectionner une adresse valide dans les propositions.";

			try {
				this.isSubmitting = true;
				this.errorMessage = "";

				const body = JSON.stringify(this.property);
				const response = await fetch(process.env.VUE_APP_API_URL + "logements/add", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include", body, });
				const data = await response.json();

				if (!response.ok) return this.errorMessage = "Erreur lors de la soumission des données. Veuillez réessayer.";

				this.errorMessage = "";
				localStorage.setItem("currentProperty", JSON.stringify(data));
				this.$router.push('/').then(() => {
					window.location.reload();
				});
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
				this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
			} finally {
				this.isSubmitting = false;
			}
		},
	},
};
</script>

<style scoped>
.form-control.type,
.form-control.fiscal {
	flex: 0.5;
}

.form-control.address {
	position: relative;
}
</style>
